var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10V11.8C12.5 12.1183 12.3736 12.4235 12.1485 12.6485C11.9235 12.8736 11.6183 13 11.3 13H4.7C4.38174 13 4.07652 12.8736 3.85147 12.6485C3.62643 12.4235 3.5 12.1183 3.5 11.8V5.2C3.5 4.88174 3.62643 4.57652 3.85147 4.35147C4.07652 4.12643 4.38174 4 4.7 4H6.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49998 8.99998L13.5 2.99995M13.5 2.99995L9.5 2.99996M13.5 2.99995L13.5 6.99996",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalOpen);
export default __webpack_public_path__ + "static/media/externalOpen.1bc524c7acda9ae52e63aba885a0b013.svg";
export { ForwardRef as ReactComponent };